import React, { useState } from 'react';
import api from '../api/questions';

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      // Envoi des informations d'identification au backend
      const response = await api.post('/api/auth/login', {
        email,
        password,
      });

      // Stockage des informations utilisateur dans localStorage
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('userId', response.data.userId);
      localStorage.setItem('email', response.data.email);
      localStorage.setItem('isAdmin', response.data.isAdmin); // Stockage du statut admin

      setMessage('Connexion réussie');
      if (onLogin) {
        onLogin(); // Mise à jour de l'état dans le composant parent
      }
    } catch (error) {
      // Gestion des erreurs
      setMessage(error.response?.data?.message || 'Erreur lors de la connexion');
      console.error('Erreur lors de la connexion :', error.message);
    }
  };

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>Connexion</h1>
      <form onSubmit={handleLogin}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <br />
        <input
          type="password"
          placeholder="Mot de passe"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <br />
        <button type="submit">Se connecter</button>
      </form>
      {message && <p style={{ color: message === 'Connexion réussie' ? 'green' : 'red' }}>{message}</p>}
    </div>
  );
};

export default Login;
